// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { cog16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-cog': IconCog;
    }
}

/**
 * The icon component for the 'cog' icon
 */
export class IconCog extends Icon {
    public constructor() {
        super(cog16X16);
    }
}

registerIcon('icon-cog', IconCog);
export const iconCogTag = 'nimble-icon-cog';
